import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {noSpacingBottom} from 'styles/Utilities';

export interface FieldErrorProps {
  // If compact, don't display bottom spacing. This is useful for putting fields in tables for example.
  compact?: boolean;
  message?: Array<string> | string | null;
}

function LegacyFieldError({compact = false, message = null}: FieldErrorProps): JSX.Element | null {
  // If an error is actually present, display the (first) message. Otherwise, show nothing.
  return message == null ? null : (
    <span className={classNames('legacy-field-error', css(compact && fieldErrorStyles.noSpacingBottom))}>
      {message instanceof Array ? message[0] : message}
    </span>
  );
}

export default LegacyFieldError;

export const fieldErrorStyles = StyleSheet.create({
  // Can't use .u-no-spacing-bottom for LegacyFieldError because css "importance" order depends on definition
  // order, and it seems like almostflat.less, which defines the legacy-field-error's spacing, is imported
  // after utility.less somewhere in our codebase.
  noSpacingBottom,
});
